import type { VariantProps } from 'class-variance-authority'

import { Button as ButtonPrimitive } from '@base-ui/react/button'
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const buttonVariants = cva(
    'group/button inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-xl border border-transparent bg-clip-padding font-semibold whitespace-nowrap transition-all outline-none select-none focus-visible:ring-4 focus-visible:ring-ring/40 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*=\'size-\'])]:size-4',
    {
        variants: {
            variant: {
                default: 'bg-primary text-primary-foreground shadow-sm shadow-primary/25 hover:bg-primary/90',
                outline: 'border-border bg-card text-foreground hover:border-primary/30 hover:bg-accent hover:text-accent-foreground',
                secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/70',
                ghost: 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
                destructive: 'bg-destructive/10 text-destructive hover:bg-destructive/20',
                link: 'text-primary underline-offset-4 hover:underline'
            },
            size: {
                default: 'h-10 px-4 text-sm',
                sm: 'h-9 rounded-lg px-3 text-sm',
                lg: 'h-12 px-5 text-base [&_svg:not([class*=\'size-\'])]:size-5',
                xl: 'h-14 rounded-2xl px-6 text-base [&_svg:not([class*=\'size-\'])]:size-5',
                icon: 'size-10',
                'icon-sm': 'size-9 rounded-lg'
            }
        },
        defaultVariants: {
            variant: 'default',
            size: 'default'
        }
    }
)

function Button({
    className,
    variant = 'default',
    size = 'default',
    ...props
}: ButtonPrimitive.Props & VariantProps<typeof buttonVariants>) {
    return (
        <ButtonPrimitive
            data-slot='button'
            className={cn(buttonVariants({ variant, size, className }))}
            {...props}
        />
    )
}

export { Button, buttonVariants }
